import React, { useState } from "react";
import { Button } from "@sscs/ui";
import { AddCircleIcon } from "@sscs/ui/icons";
import { useDialog } from "Hooks";
import GenerateToken from "./GenerateToken";
import TokenGenerated from "./TokenGenerated";

type GenerateAccessTokenProps = {
  isDisabled: boolean;
};

const GenerateAccessToken = ({
  isDisabled,
}: GenerateAccessTokenProps): React.JSX.Element => {
  const [generatedToken, setGeneratedToken] = useState<string | null>(null);
  const dialog = useDialog();

  const openDialog = (): void => {
    setGeneratedToken(null);
    dialog.open();
  };

  return (
    <>
      <Button
        onClick={openDialog}
        disabled={isDisabled}
        tooltipTitle={
          isDisabled
            ? "You have reached the maximum number of access tokens"
            : ""
        }
      >
        <AddCircleIcon />
        Generate new token
      </Button>
      {generatedToken ? (
        <TokenGenerated
          generatedToken={generatedToken}
          isOpen={dialog.isOpen}
          onClose={dialog.close}
        />
      ) : (
        <GenerateToken
          isOpen={dialog.isOpen}
          onClose={dialog.close}
          onGenerated={(token) => setGeneratedToken(token)}
        />
      )}
    </>
  );
};

export default GenerateAccessToken;
